import { flattenTree } from '@shared/helpers/tree.helpers';
import { OneOfListElements } from '@shared/models/project.model';
import { getUIState } from '@client/store/ui';

/**
 * Ids of all descendants of {@link parent}, excluding the parent itself.
 */
export const getDescendantElementIds = (parent: OneOfListElements): string[] =>
  flattenTree<OneOfListElements>(parent, 'elements')
    .filter((e) => e.id !== parent.id)
    .map((e) => e.id);

/**
 * Clears element/folder selection when collapsing {@link parent} would hide the selected row.
 */
export const clearSelectionForCollapsedDescendants = (
  parent: OneOfListElements,
  navigateTo: (params: { elementId: 'none' }) => void,
): void => {
  const descendantIds = getDescendantElementIds(parent);
  const {
    selectedProjectFolderId: selectedFolderId,
    setSelectedProjectFolderId,
    selectedElementId,
  } = getUIState();

  if (selectedFolderId && descendantIds.includes(selectedFolderId)) {
    setSelectedProjectFolderId(undefined);
  }
  if (selectedElementId && descendantIds.includes(selectedElementId)) {
    navigateTo({ elementId: 'none' });
  }
};
